import React from 'react';
import className from 'classnames';
import moment from 'moment';
import {get, head} from 'lodash';
import axios from 'axios';

import {
  CSRF_TOKEN,
  requestCallback,
} from '../lib/helpers';

import {
  useCheckIds,
  useModal,
} from '../hooks';

import TableHeader from './TableHeader';
import BGMModal from './BGMModal';
import ModalDelete from './ModalDelete';

const BackgroundMusicsList = ({
  backgroundMusics = [],
  total = 0,
}) => {
  const {
    checkIds,
    renderCheckBox, renderCheckBoxForCheckAll,
  } = useCheckIds({
    data: backgroundMusics,
  })

  const [
    modal,
    modalSet,
  ] = useModal({
    keyboardBindings: true,
  })

  const inactive = (id) => {
    requestCallback(axios.put(`/${gon.currentProvider}/api/background_musics/${id}/inactive`, {
      authenticity_token: CSRF_TOKEN,
    }))
  }

  const active = (id) => {
    requestCallback(axios.put(`/${gon.currentProvider}/api/background_musics/${id}/active`, {
      authenticity_token: CSRF_TOKEN,
    }))
  }

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Background Musics list</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} audios</p>
        </div>

        <div className='MainHeader__right'>
          <BGMModal
            klassName='MainHeader__right__a MainHeader__right__a--bright-blue'
            label='Add Background Music'
            title='Add Background Music'
            reload
          />
        </div>
      </div>

      <div className='TableChecker'>
        {renderCheckBoxForCheckAll()}
      </div>

      <div className='Table Table--background-musics-list'>
        {(() => {
          const columnHeaders = [
            {
              label: '',
            },
            {
              label: 'ID',
              sortKey: 'id',
            },
            {
              label: 'Title',
            },
            {
              label: 'Audio',
            },
            {
              label: 'Status',
            },
            {
              label: 'Created at',
              sortKey: 'created_at',
            },
            {
              label: 'Order'
            },
            {
              label: 'Manage',
            },
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {backgroundMusics.map((backgroundMusic) => (
          <div
            className={className('Table__row', {
              'Table__row--active': checkIds.includes(backgroundMusic.id),
            })}
            key={`${backgroundMusic.id}_${backgroundMusic.createdAt}`}
            data-x={backgroundMusic}
          >
            <div className='Table__col'>
              {renderCheckBox(backgroundMusic)}
            </div>
            <div className='Table__col'>{backgroundMusic.id}</div>

            <div className='Table__col'>{backgroundMusic.title}</div>
            <div className='Table__col'>
              <audio className='Audio' src={backgroundMusic.music.url} controls />
            </div>
            <div className='Table__col'>
              {backgroundMusic.active ?
                <span className='Badge'>Active</span>
              :
                <span className='Badge Badge--orange'>Inactive</span>
              }
            </div>

            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: backgroundMusic.createdAt !== null ?
                    moment(backgroundMusic.createdAt).format('YYYY-MM-DD<br />HH:mm')
                  :
                    'N/A'
                }
              }
            />

            <div className='Table__col'>{backgroundMusic.order}</div>
            <div className='Table__col'>
              <div className='Table__controls'>
                <BGMModal
                  klassName='Table__controls__a Table__controls__a--pencil'
                  title='Edit Background Music'
                  backgroundMusic={backgroundMusic}
                  reload
                />
                <a
                  className={`Table__controls__a Table__controls__a--${backgroundMusic.active ? 'eye-close' : 'eye'}`}
                  onClick={backgroundMusic.active ? () => inactive(backgroundMusic.id) : () => active(backgroundMusic.id)}
                />
                <ModalDelete
                  type='background_music'
                  id={get(backgroundMusic, 'id')}
                  klassName='Table__controls__a Table__controls__a--trash'
                  reload
                  hideText
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default BackgroundMusicsList
